import React, { createRef } from 'react';
import {
  focusFirstFocusableNode,
  focusLastFocusableNode,
} from 'ui/utilities/focus';

class ModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  modalContainerRef = createRef();

  componentDidMount() {
    window.addEventListener('keyup', this.handleEscapeKey);
    document.body.classList.add('no-scroll');
    if (this.modalContainerRef.current && !this.props.manualAutoFocus) {
      focusFirstFocusableNode(this.modalContainerRef.current);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
    window.removeEventListener('keyup', this.handleEscapeKey);
  }

  handleEscapeKey(e) {
    const keyCode = e.keyCode || e.which;
    if (this.props.onEscape && keyCode === 27) {
      this.props.onEscape();
    }
  }

  handleFocusWrap = first => () => {
    if (this.modalContainerRef.current) {
      if (first) {
        focusLastFocusableNode(this.modalContainerRef.current);
      } else {
        focusFirstFocusableNode(this.modalContainerRef.current);
      }
    }
  };

  render() {
    const { onEscape, manualAutoFocus, ...props } = this.props;
    return (
      <>
        <div
          role="button"
          tabIndex={0}
          aria-hidden="true"
          onFocus={this.handleFocusWrap(true)}
        />
        <div {...props} ref={this.modalContainerRef} />
        <div
          role="button"
          tabIndex={0}
          aria-hidden="true"
          onFocus={this.handleFocusWrap(false)}
        />
      </>
    );
  }
}

export default ModalContainer;
